import React from 'react';
import { Hero } from '../components/sections/Hero';
import { StatsBand } from '../components/sections/StatsBand';
import { ServicesSection } from '../components/sections/ServicesSection';
import { AboutSection } from '../components/sections/AboutSection';
import { ProjectGallery } from '../components/sections/ProjectGallery';
import { ProcessSection } from '../components/sections/ProcessSection';
import { EmergencyCTA } from '../components/sections/EmergencyCTA';
import { Testimonials } from '../components/sections/Testimonials';
import { FAQSection } from '../components/sections/FAQSection';
import { ContactSection } from '../components/sections/ContactSection';
import { WaveDivider } from '../components/fx/WaveDivider';
export function Home() {
  return <>
      <Hero data-id="element-458" data-mp="2dfdthvpfawua" />
      <StatsBand data-id="element-459" data-mp="3kvk62l8hf36i" />
      <div className="deferred-section" data-id="element-460" data-mp="3kw1yt7vxqz9o">
        <ServicesSection limit={8} data-id="element-461" data-mp="3kv0ox6qnoitj" />
      </div>
      <WaveDivider color="#F5FAFF" data-id="element-462" data-mp="3owcfbehct82s" />
      <div className="deferred-section bg-mist" data-id="element-463" data-mp="3ovarsaj5it46">
        <AboutSection data-id="element-464" data-mp="30wjd0qrxiw5e" />
      </div>
      <WaveDivider color="#F5FAFF" flip data-id="element-465" data-mp="30vqay33x0utl" />
      <div className="deferred-section" data-id="element-466" data-mp="30ufb2edlc77r">
        <ProjectGallery data-id="element-467" data-mp="2vxf5s5okf8hp" />
      </div>
      <div className="deferred-section" data-id="element-468" data-mp="2vyht63moissv">
        <ProcessSection data-id="element-469" data-mp="2qybzkhwumw85" />
      </div>
      <div className="deferred-section" data-id="element-470" data-mp="2qxale4kjdtm7">
        <EmergencyCTA data-id="element-471" data-mp="2r0gcfpcq75kk" />
      </div>
      <div className="deferred-section" data-id="element-472" data-mp="2mxs21d8d5qlh">
        <Testimonials data-id="element-473" data-mp="2mwqql7nfr238" />
      </div>
      <WaveDivider color="#F5FAFF" data-id="element-474" data-mp="2hxnj7gjzgjs3" />
      <div className="deferred-section bg-mist" data-id="element-475" data-mp="2hyyv63nl0xua">
        <FAQSection data-id="element-476" data-mp="2d775rwg5wy5q" />
      </div>
      <WaveDivider color="#F5FAFF" flip data-id="element-477" data-mp="2d6xcnzztmavt" />
      <div className="deferred-section" data-id="element-478" data-mp="2d5w2ryujjufo">
        <ContactSection data-id="element-479" data-mp="287ksjn0c3hwx" />
      </div>
    </>;
}